module.exports = __webpack_public_path__ + "static/media/4@2x.5f2c110d.png";